import React, { useContext, useEffect, useMemo, useState } from 'react';
import '../SHEventInfoPage.css';
import { TbCaretDownFilled, TbCaretUpFilled } from 'react-icons/tb';
import { useLanguage } from '../../../../../LanguageProvider';
import { useToaster } from '../../../../../ToasterProvider';
import { GeneralContext } from '../../../../../GeneralProvider';
import Services from '../../../../../services/Services';
import AddSpeakerModal from '../../../components/AddSpeakerModal/AddSpeakerModal';
import SHSpeakerCard from '../../../components/SHSpeakerCard/SHSpeakerCard';
import AddSponsorModal from '../../../components/AddSponsorModal/AddSponsorModal';
import SHSponsorCard from '../../../components/SHSponsorCard/SHSponsorCard';
import SHEventCommentBox from './SHEventCommentBox';
import SHEventInfoBox from './SHEventInfoBox';

export default function SHEventDetail({ event, isAdmin, getEventDetails, activeTab, isPreview = false, channelTitle = "", channelLogo = "", participantCount = 0, soldTicketsCount = 0 }) {
    const { getTranslation } = useLanguage();

    const { setCreateProjectLoading } = useContext(GeneralContext);
    const { toastError, toastSuccess } = useToaster();
    const token = localStorage.getItem("token")
    const [isSpeakerModalOpen, setIsSpeakerModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [showFullDesc, setShowFullDesc] = useState(false)
    const toggleDescription = () => setShowFullDesc(prev => !prev)

    const isDataReady = useMemo(() => {
        if (!event) return false;
        if (Object.keys(event).length === 0) return false;
        // cover veya title/description geldiyse yeterli say
        return Boolean(event.cover || event.title || event.description || event.speakers || event.sponsors);
    }, [event]);


    const handleCloseSponsorModal = () => {
        setIsModalOpen(false)
    }

    const handleAddSponsor = (companyTitle, companyAbout, sponsorshipType, sponsorshipAbout, image) => {
        setCreateProjectLoading(true)
        Services.SocialHiveAddSponsor(token, event.channelID, event.eventID, companyTitle, companyAbout, sponsorshipType, sponsorshipAbout, image)
            .then((res) => {
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"))
                    getEventDetails()
                    handleCloseSponsorModal()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
                setCreateProjectLoading(false)
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }

    const handleCloseModal = () => {
        setIsSpeakerModalOpen(false)
    }

    const handleAddSpeaker = (name, lastname, about, image, speakingAboutTitle, speakingAbout, linkedin) => {
        setCreateProjectLoading(true)
        Services.SocialHiveAddSpeaker(token, event?.channelID, event?.eventID, name, lastname, speakingAboutTitle, speakingAbout, about, image, linkedin)
            .then((res) => {
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"))
                    getEventDetails()
                    handleCloseModal()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
                setCreateProjectLoading(false)
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }

    const descriptionPreview = event?.description.length > 700 && !showFullDesc
        ? event?.description.slice(0, 700) + "..."
        : event?.description

    useEffect(() => {
        getEventDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isDataReady) {
        return (
            <div style={{ width: '100%', height: '100%', paddingRight: '3px', boxSizing: 'border-box' }}>
                <div className="sh-event-cover-container">
                    <div className="skeleton skeleton-cover" />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 15, margin: '10px 0 15px' }}>
                    <div className="skeleton skeleton-title" style={{ width: 180 }} />
                </div>

                <div className="sh-info-description">
                    <div className="skeleton skeleton-text" />
                    <div className="skeleton skeleton-text" />
                    <div className="skeleton skeleton-text short" />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 15, margin: '15px 0' }}>
                    <div className="skeleton skeleton-title" style={{ width: 140 }} />
                    {/* <div className="skeleton skeleton-chip" /> */}
                </div>

                <div className="social-hive-speakers-grid">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={`spk-skel-${i}`} className="skeleton-card" style={{ width: '25%', flexDirection: 'row', display: 'flex', gap: '12px' }}>
                            <div className="skeleton skeleton-avatar" />
                            <div style={{ width: '100%' }}>
                                <div className="skeleton skeleton-text" />
                                <div className="skeleton skeleton-text short" />
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 15, margin: '15px 0' }}>
                    <div className="skeleton skeleton-title" style={{ width: 140 }} />
                    {/* <div className="skeleton skeleton-chip" /> */}
                </div>

                <div className="social-hive-speakers-grid">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={`spk-skel-${i}`} className="skeleton-card" style={{ width: '25%', flexDirection: 'row', display: 'flex', gap: '12px' }}>
                            <div className="skeleton skeleton-avatar" />
                            <div style={{ width: '100%' }}>
                                <div className="skeleton skeleton-text" />
                                <div className="skeleton skeleton-text short" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }


    return (
        <div className="sh-event-detail-container" style={{ width: '100%', height: '100%', overflowY: 'auto', paddingRight: '3px', boxSizing: 'border-box' }}>
            <div className="sh-event-cover-container">
                <img
                    src={event?.cover}
                    alt={event?.title}
                    className="sh-event-cover-image"
                />
            </div>

            {isPreview &&
                <SHEventInfoBox event={event} channelTitle={channelTitle} channelLogo={channelLogo} participantCount={participantCount} soldTicketsCount={soldTicketsCount} isPreview={isPreview} style={{width:'100%',marginTop:'10px'}}/>
            }

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px', marginTop: '10px' }}>
                <span className='sh-speakers-title'>{getTranslation('aboutEvent')}</span>
            </div>
            <p className="sh-info-description" style={{ textAlign: 'left' }}>
                {descriptionPreview}
                {event?.description.length > 700 && (
                    <button
                        className="sh-ticket-card-showmore"
                        onClick={toggleDescription}
                    >
                        {showFullDesc ?
                            <span className="sh-ticket-card-description-carot">{getTranslation("showLess")} <TbCaretUpFilled /></span> :
                            <span className="sh-ticket-card-description-carot">{getTranslation("showMore")} <TbCaretDownFilled /> </span>
                        }

                    </button>
                )}
            </p>

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                <span className='sh-speakers-title'>{getTranslation('speakers')}</span>
                {isAdmin === "1" &&
                    <span className="sh-details-title" onClick={() => setIsSpeakerModalOpen(true)} >
                        <span>{getTranslation('addNewSpeaker')}</span>
                    </span>}
            </div>

            <div className="sh-info-description">

                {event?.speakers ? (
                    <div className="social-hive-speakers-grid">
                        {event?.speakers.map((speaker, index) => (
                            <SHSpeakerCard
                                isAdmin={isAdmin}
                                key={index}
                                name={`${speaker.name} ${speaker.lastname}`}
                                image={speaker.image}
                                title={speaker.speakingAboutTitle === "-" ? speaker.about : (speaker.speakingAboutTitle || speaker.about)}
                            linkedin={speaker?.socialMediaLinks?.linkedin || speaker?.linkedin}
                                eventID={event?.eventID}
                                speakerID={speaker.speakerID}
                                getEventDetails={getEventDetails}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="sh-location" style={{ marginTop: "12px" }}>
                        <span>{getTranslation('noSpeakersYet')}</span>
                    </div>
                )}

            </div>

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px', marginTop: '15px' }}>
                <span className='sh-speakers-title'>{getTranslation('sponsors')}</span>
                {isAdmin === "1" &&
                    <span className="sh-details-title" onClick={() => setIsModalOpen(true)} >
                        <span>{getTranslation('addNewSponsor')}</span>
                    </span>}
            </div>

            <div className="sh-info-description">

                {event.sponsors ? (
                    <div className="social-hive-speakers-grid">
                        {event.sponsors.map((sponsor, index) => (
                            <SHSponsorCard
                                isAdmin={isAdmin}
                                key={index}
                                name={sponsor.companyTitle}
                                image={sponsor.image}
                                title={sponsor.sponsorshipType}
                                eventID={event.eventID}
                                sponsorID={sponsor.sponsorID}
                                getEventDetails={getEventDetails}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="sh-location" style={{ marginTop: "12px" }}>
                        <span>{getTranslation('noSponsorsYet')}</span>
                    </div>
                )}

            </div>

            {(activeTab !== "payment" && activeTab !== getTranslation('tickets') && isPreview === false) && <SHEventCommentBox comments={event?.comments} event={event} />}


            <AddSponsorModal
                isOpen={isModalOpen}
                onClose={handleCloseSponsorModal}
                onCreate={handleAddSponsor}
                isWorkspace={true}
            />

            <AddSpeakerModal
                isOpen={isSpeakerModalOpen}
                onClose={handleCloseModal}
                onCreate={handleAddSpeaker}
                isWorkspace={true}
            />
        </div>

    );
}
